import { useEffect } from "react";
import useAppBrandInfo from "../hooks/useAppBrandInfo";

export default function BrandMetadataSync() {
  const { data: brandInfo } = useAppBrandInfo();

  useEffect(() => {
    if (!brandInfo) return;

    // 1. Update Document Title
    if (brandInfo.product_name && brandInfo.app_name) {
      document.title = `${brandInfo.product_name} | ${brandInfo.app_name}`;
    } else if (brandInfo.product_name) {
      document.title = brandInfo.product_name;
    } else if (brandInfo.app_name) {
      document.title = brandInfo.app_name;
    }

    // 2. Update Favicon Link
    if (brandInfo.fav_icon_url) {
      let favicon = document.querySelector("link[rel*='icon']");
      if (!favicon) {
        favicon = document.createElement("link");
        favicon.rel = "icon";
        document.head.appendChild(favicon);
      }
      favicon.href = brandInfo.fav_icon_url;
    }

    // 3. Update Meta Description
    if (brandInfo.product_description) {
      let metaDesc = document.querySelector("meta[name='description']");
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.name = "description";
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = brandInfo.product_description;
    }
  }, [brandInfo]);

  return null;
}
